import { motion } from "framer-motion";

const chapters = [
    {
        n: "01",
        title: "Painting",
        body: "Cabinet, door, trim, interior, exterior — plus drywall repair, popcorn removal, staining, epoxy, and pressure washing. Precise prep, premium finishes.",
    },
    {
        n: "02",
        title: "Construction",
        body: "Concrete, demolition, framing, drywall, flooring, tile, roofing, doors & windows, decks, fencing, and full remodels. Structural work handled with plan, permit, and pride.",
    },
    {
        n: "03",
        title: "Trust",
        body: "Greenwell Springs / Baton Rouge locals. Licensed & insured. Clear estimates, honest timelines, and a phone that gets answered. From small repairs to full renovations — we do it all.",
    },
];

export default function Manifesto({ content }) {
    return (
        <section id="about" data-testid="manifesto-section" className="relative bg-[color:var(--bg-primary)] py-24 md:py-40 overflow-hidden">
            <div className="mx-auto max-w-[1440px] px-6 md:px-10">
                <div className="grid grid-cols-12 gap-8">
                    <div className="col-span-12 lg:col-span-4">
                        <motion.div
                            initial={{ opacity: 0, y: 30 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, margin: "-120px" }}
                            transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
                        >
                            <div className="font-mono text-[11px] uppercase tracking-[0.25em] text-neutral-500 mb-6">
                                [ Manifesto ]
                            </div>
                            <h2 className="font-display text-5xl md:text-6xl font-black tracking-tighter leading-[0.9] text-neutral-900">
                                Craft over<br />shortcuts.
                            </h2>
                            <p className="mt-6 max-w-md text-base text-neutral-600 leading-relaxed">
                                {content.about_paragraph}
                            </p>
                        </motion.div>
                    </div>

                    <div className="col-span-12 lg:col-span-8 lg:pl-16 lg:border-l border-neutral-900/10">
                        <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-neutral-900/10">
                            {chapters.map((c, i) => (
                                <motion.article
                                    key={c.n}
                                    initial={{ opacity: 0, y: 30 }}
                                    whileInView={{ opacity: 1, y: 0 }}
                                    viewport={{ once: true, margin: "-100px" }}
                                    transition={{ delay: i * 0.12, duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
                                    className="group bg-[color:var(--bg-primary)] p-6 md:p-8 hover:bg-white transition-colors"
                                    data-testid={`manifesto-chapter-${c.n}`}
                                >
                                    <div className="font-mono text-sm text-[color:var(--brand-blue)]">{c.n}</div>
                                    <h3 className="mt-6 font-display text-2xl md:text-3xl font-bold tracking-tight text-neutral-900">
                                        {c.title}
                                    </h3>
                                    <p className="mt-4 text-sm text-neutral-600 leading-relaxed">{c.body}</p>
                                    <div className="mt-8 h-px w-8 bg-[color:var(--brand-blue)] group-hover:w-24 transition-all duration-500" />
                                </motion.article>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
